export default class MissingTranslationError extends Error {
  constructor(locale: string, getTranslation: Function) {
    super(`Missing ${locale.toUpperCase()} translation for ${getTranslation}`);
  }
}
